import { render, staticRenderFns } from "./Conclusion_rational_print.vue?vue&type=template&id=6a9cb4b2&scoped=true&"
import script from "./Conclusion_rational_print.vue?vue&type=script&lang=js&"
export * from "./Conclusion_rational_print.vue?vue&type=script&lang=js&"
import style0 from "./Conclusion_rational_print.vue?vue&type=style&index=0&id=6a9cb4b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9cb4b2",
  null
  
)

export default component.exports
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSlider,QCircularProgress,QIcon});
